<template>
    <img ref="imageRef"
         class="wb-image"
         v-bind.attr="$attrs"
         :[srcAttribute]="src"
         :alt="alt"
         :class="classess"
         data-allow-mismatch
         @load="onLoad"
    />
</template>

<script setup lang="ts">
    import { useLazyLoad } from '~/src/shared/composables/client/images/useLazyLoad'

    const props = withDefaults(defineProps<{
        src: string
        alt?: string
        lazy?: boolean
        aspectRatio?: string | [number, number]
    }>(), {
        lazy: true,
    })

    const isLoaded = ref(false)
    const imageRef = ref<HTMLImageElement>()

    const classess = computed(() => ({ loaded: isLoaded.value, lazy: props.lazy, aspect: props.aspectRatio }))

    const srcAttribute = computed(() => {
        return props.lazy ? 'data-src' : 'src'
    })

    const onLoad = () => {
        isLoaded.value = true
    }

    const aspectRatio = computed(() => {
        if (typeof props.aspectRatio === 'string') {
            const regex = /[/,:]/
            const ratio = props.aspectRatio.split(regex)

            return [ratio[0], ratio[1]]
        } else {
            return [0, 0]
        }
    })

    const aspect = useCssVar('--aspect-ratio', imageRef, { initialValue: `${aspectRatio.value?.[0]}/${aspectRatio.value?.[1]}` || null })

    useLazyLoad('400px')
</script>

<style lang="scss">
    .wb-image {
        &.lazy {
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        &.lazy.loaded {
            opacity: 1;
        }

        &.aspect {
            aspect-ratio: v-bind(aspect);
        }
    }
</style>
